import { render, staticRenderFns } from "./message.vue?vue&type=template&id=760fd4ee&scoped=true"
import script from "./message.vue?vue&type=script&lang=ts"
export * from "./message.vue?vue&type=script&lang=ts"
import style0 from "./message.vue?vue&type=style&index=0&id=760fd4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760fd4ee",
  null
  
)

export default component.exports